// All 12 images bundled directly from src/assets/images/
export const IMAGES = {
  heroBackground:   require('../assets/images/hero_background.png'),
  bentoNature:      require('../assets/images/bento_nature.png'),
  projectPhoto:     require('../assets/images/project_photo.png'),
  aboutHero:        require('../assets/images/about_hero.png'),
  aboutPhoto1:      require('../assets/images/about_photo1.png'),
  aboutPhoto2:      require('../assets/images/about_photo2.png'),
  contactHero:      require('../assets/images/contact_hero.png'),
  contactMap:       require('../assets/images/contact_map.png'),
  solutionHeatpump: require('../assets/images/solution_heatpump.png'),
  solutionLighting: require('../assets/images/solution_lighting.png'),
  solutionHeating:  require('../assets/images/solution_heating.png'),
  solutionSolar:    require('../assets/images/solution_solar.png'),
};
